import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { FaTimes, FaUserPlus, FaChevronRight } from 'react-icons/fa';
import { showSuccess, showError, showLoading, closeLoading } from '../../../utils/Alert';
import './UserModals.css';

const AddUserModal = ({ isOpen, onClose, onUserAdded }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => { document.body.style.overflow = 'unset'; };
    }, [isOpen]);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        role: 'tutor',
        tempPassword: ''
    });

    const rolesList = [
        { value: 'tutor', label: 'Tutor / Instructor' },
        { value: 'recruiter', label: 'Corporate Recruiter' },
        // { value: 'support_staff', label: 'Operations Support' },
    ];

    const generateTempPassword = () => {
        const pass = Math.random().toString(36).slice(-8) + '!' + Math.floor(Math.random() * 10);
        setFormData({ ...formData, tempPassword: pass });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        showLoading('Provisioning Identity...');
        try {
            await axios.post('/api/admin/invite', formData, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            closeLoading();
            showSuccess('User Provisioned', `Invite sent to ${formData.email}`);
            onUserAdded();
            onClose();
            setFormData({ name: '', email: '', role: 'tutor', tempPassword: '' });
        } catch (err) {
            closeLoading();
            showError('Provisioning Failed', err.response?.data?.message || 'Error occurred');
        }
    };

    return ReactDOM.createPortal(
        <div className={`modal-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2><FaUserPlus /> Provision New Identity</h2>
                    <button className="modal-close-btn" onClick={onClose}><FaTimes /></button>
                </div>

                <div className="modal-body">
                    <p className="modal-desc">
                        Create a new authorized entity within the platform. A temporal credential will be generated for the user's initial authentication.
                    </p>

                    <form onSubmit={handleSubmit} className="modal-form">
                        <div className="form-group">
                            <label className="premium-label">Full Name</label>
                            <input
                                type="text"
                                className="glass-input"
                                placeholder="e.g. Alexander Pierce"
                                value={formData.name}
                                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label className="premium-label">Email Coordinate</label>
                            <input
                                type="email"
                                className="glass-input"
                                placeholder="entity@platform.com"
                                value={formData.email}
                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label className="premium-label">Access Role</label>
                            <select
                                className="glass-input"
                                value={formData.role}
                                onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                            >
                                {rolesList.map(role => (
                                    <option key={role.value} value={role.value}>{role.label}</option>
                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label className="premium-label">Temporal Credential</label>
                            <div className="input-group-row">
                                <input
                                    type="text"
                                    className="glass-input"
                                    value={formData.tempPassword}
                                    readOnly
                                    placeholder="Click generate →"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={generateTempPassword}
                                    className="action-btn-gold"
                                    style={{ padding: '0 24px', minWidth: '130px', height: '48px' }}
                                >
                                    Generate
                                </button>
                            </div>
                        </div>

                        <div className="modal-actions">
                            <button type="button" className="action-btn-secondary" onClick={onClose}>
                                Cancel
                            </button>
                            <button type="submit" className="action-btn-gold pulse-on-hover">
                                Complete Provisioning <FaChevronRight style={{ marginLeft: '10px' }} />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default AddUserModal;
